/**
 * Animation and transition-related semantic tokens for PrimeNG preset.
 * Transitions are PrimeNG-specific; the focus ring uses semantic tokens.
 */
import { type SemanticTokens, focus } from '../tokens/semantic.js';

export const animations = {
  // Transition & Animation (PrimeNG-specific)
  transitionDuration: '0.2s',
  transition: {
    normal: '0.2s',
    duration: '0.2s',
    fast: '0.1s',
    slow: '0.3s',
  },

  // Focus Ring (from semantic.ts focus tokens)
  focusRing: {
    width: '2px',
    style: 'solid',
    color: focus.ring,
    offset: '2px',
    shadow: 'none',
  },
  focus: {
    ring: {
      width: '2px',
      style: 'solid',
      color: focus.ring,
      offset: '2px',
      shadow: 'none',
    },
  },

  // Mask tokens
  mask: {
    transitionDuration: '0.1s',
  },
};

export function createAnimations(s: SemanticTokens) {
  return {
    ...animations,
    focusRing: {
      ...animations.focusRing,
      color: s.focus.ring,
    },
    focus: {
      ring: {
        ...animations.focus.ring,
        color: s.focus.ring,
      },
    },
  };
}
